import { gql } from 'graphql-request'

export namespace TicketTypesQueries {
  export const QUERY_KEY = 'getTicketTypes'

  export function getTicketTypes() {
    return gql`
      query TicketTypes($filter: TicketTypeFilter) {
        ticketTypes(filter: $filter) {
          id
          description
          allowAsParent
        }
      }
    `
  }
}
